import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BASE_API_URL } from '../network/api-config';

const MESSAGE_API_URL = BASE_API_URL + 'message';

interface ISuccess {
  success: boolean;
}

/**
 * Local fork of @curbnturf/contact's ContactService — trimmed to plain
 * HttpClient. Only send() is used, and contact.component.ts always supplies
 * `message.user` explicitly, so the real class's AuthFacade.user$ branch
 * (the only reason it depended on @curbnturf/auth's NgRx facade) is never
 * taken — dropped rather than ported. sendPayoutRequest/
 * sendCaretakerRequest/sendCashPayoutRequest aren't used.
 */
@Injectable({ providedIn: 'root' })
export class ContactApiService {
  private readonly http = inject(HttpClient);

  send(message: { email: string; user?: string; body: string }): Observable<ISuccess> {
    return this.http.post<ISuccess>(`${MESSAGE_API_URL}/contact-curbnturf`, message);
  }
}
